import React, { useEffect } from "react";
import DoctorPhoto from '../../assets/images/dashboard/profile-1.svg';
import { Image } from "../componentIndex";
import StarIcon from '../../assets/images/dashboard/star.svg';
import { stringToHslColor, getInitials, getDarkerHslColor } from '../../helper/extension';

const DoctorDetails = ({ doctorInformation, isConfirmRequest }) => {

    const getName = (name) => {
        if (name) {
            let findName = name?.split(',')[0]?.split(' ');

            const initials = getInitials(findName[0], findName[1]);
            return initials;
        }

    }
    const getBGColor = (name) => {
        if (typeof name !== 'string' || name === null || name === undefined) {
            return null; // Handle case when name is not a valid string
        }

        if (!isNaN(name)) {
            // let findName = name?.replace(' ', '');
        } else {
            let findName = name?.replace(' ', '');
            const bgColor = stringToHslColor(findName);
            return bgColor;
        }


    }

    return (
        <>
            {doctorInformation && (
                <div className="doctor-detail">
                    {doctorInformation?.photo ? (
                        <div className="doctor-photo" style={{
                            backgroundImage: `url(${doctorInformation?.photo})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat'
                        }}>

                        </div>
                    ) : (
                        <>
                            {doctorInformation && (
                                <>
                                    <div className="doctor-photo"
                                        style={{
                                            backgroundColor: getBGColor(doctorInformation?.firstName?.charAt(0) + doctorInformation?.lastName?.charAt(0)),
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#fff',
                                            fontWeight: 400,
                                            fontFamily: `'SF UI Display', sans-serif`,
                                            fontSize: '40px',
                                            border: `2px solid ${getDarkerHslColor(
                                                doctorInformation?.firstName?.charAt(0) + doctorInformation?.lastName?.charAt(0)
                                            )}`
                                        }}>
                                        {getName(doctorInformation.name)}

                                    </div>
                                </>
                            )}
                        </>
                    )}

                    <div className="doctor-information">
                        <p className="name">{doctorInformation.name}</p>
                        {doctorInformation.specialization && (
                            <p className="specialization">{doctorInformation.specialization}</p>
                        )}
                        {isConfirmRequest ? (
                            <p className="hospital-name">{doctorInformation?.organizationName}</p>
                        ) : (
                            <>
                                {doctorInformation.address && (
                                    <p className="hospital-name">{doctorInformation.organizationName}</p>
                                )}
                            </>
                        )}


                        {doctorInformation.rating !== '0 (0)' && doctorInformation.rating && (
                            <div className="rating">
                                <span><Image imgUrl={StarIcon} altText={'star'} className={'star me-2'} /> {doctorInformation.rating}</span>
                            </div>
                        )}
                    </div>
                </div>
            )
            }
        </>
    )
};

export default DoctorDetails;